import { useQuery } from '@tanstack/react-query';
import { getFolderTree } from '../../api/edms/folders';

function getTreeList(response) {
  if (!response) return [];
  const d = response.data ?? response;
  if (Array.isArray(d?.folders)) return d.folders;
  if (Array.isArray(d?.childrenFolders)) return d.childrenFolders;
  if (d?.folder && Array.isArray(d?.childrenFolders)) return d.childrenFolders;
  if (d?.folder && d.folder.children) return d.folder.children;
  if (Array.isArray(d?.children)) return d.children;
  if (Array.isArray(d)) return d;
  return [];
}

/**
 * Load folder tree. Backend returns whole tree by default.
 * Optional filters: repository, groupCategory, groupSubCategory.
 * @param {Object} [filters] - { repository?, groupCategory?, groupSubCategory? }
 * @param {Object} [options] - useQuery options (enabled, etc.)
 */
export const useFolderTree = (filters = {}, options = {}) => {
  const normalizedFilters = filters && typeof filters === 'object' && !Array.isArray(filters)
    ? filters
    : {};

  const query = useQuery({
    queryKey: ['folderTree', normalizedFilters],
    queryFn: () => getFolderTree(normalizedFilters),
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    folders: getTreeList(query.data),
  };
};

export default useFolderTree;
